<script setup>
/**
 * ItemDialogPriceErrorModal Component
 * Blocking modal for missing price error
 */
const props = defineProps({
  open: {
    type: Boolean,
    default: false,
  },
})

const emit = defineEmits(['update:open'])

function dismiss() {
  emit('update:open', false)
}
</script>

<template>
  <Teleport to="body">
    <Transition name="modal">
      <div v-if="open" class="price-error-overlay" @click.self="dismiss">
        <div class="price-error-modal">
          <div class="error-icon">
            <svg
              viewBox="0 0 24 24"
              width="48"
              height="48"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
            >
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <p class="error-message">
            לא ניתן להוסיף פריט זה לעגלה כי לא נמצא לו מחיר. אנא פנה לתמיכה.
          </p>
          <button class="dismiss-btn" @click="dismiss">הבנתי</button>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<style scoped>
.price-error-overlay {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-md);
  background: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
}

.price-error-modal {
  background: var(--bg-primary);
  border-radius: var(--border-radius);
  padding: var(--spacing-xl);
  max-width: 380px;
  width: 100%;
  text-align: center;
  box-shadow: var(--shadow-xl);
}

.error-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 72px;
  height: 72px;
  margin: 0 auto var(--spacing-lg);
  background: rgba(239, 68, 68, 0.1);
  border-radius: var(--border-radius-sm);
  color: var(--color-error);
}

.error-message {
  font-size: var(--font-size-base);
  line-height: 1.6;
  color: var(--text-primary);
  margin: 0 0 var(--spacing-lg);
}

.dismiss-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-sm) var(--spacing-xl);
  background: var(--color-primary);
  color: white;
  border: none;
  border-radius: var(--border-radius-sm);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  font-family: var(--font-family);
  cursor: pointer;
  transition: all var(--transition-fast);
}

.dismiss-btn:hover {
  background: var(--color-primary-dark);
}

.dismiss-btn:active {
  transform: scale(0.98);
}

/* Transitions */
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.2s ease;
}

.modal-enter-active .price-error-modal,
.modal-leave-active .price-error-modal {
  transition:
    transform 0.2s ease,
    opacity 0.2s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .price-error-modal,
.modal-leave-to .price-error-modal {
  opacity: 0;
  transform: scale(0.95);
}
</style>
